import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next';
import { useHistory, Redirect } from "react-router-dom";
import { useData } from "../../DataContext";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Helmet } from "react-helmet";
import {
    FormControl,
    Button,
    Typography,
    Box,
    InputLabel,
    MenuItem,
    Select,
    FormControlLabel,
    Checkbox,
    Grid
} from '@material-ui/core';

import { iAMSmartQR, iAMSmartProfile, iAMSmartToken, iAMSmartProfileTransform, delay } from '../../components/iAMSmart/iAMSmartHelper';

import { makeStyles } from '@material-ui/core/styles'

import './PersonalInfo.scss'

import iamSmartPhone from '../../images/icon-dark.png'
import iamSmartFilled from '../../images/IAMSmart_icon.jpg'
import errorWarning from '../../images/icon_warning.gif'

import {
    Navbar,
    Header,
    StepHeader,
    FormBox,
    BootstrapInput,
    Footer
} from '../../components/_index'
import { useYupValidationResolver } from '../../YupValidationResolver';
import ErrorsContainer from '../../components/ErrorsContainer/ErrorsContainer';
import Scroll from 'react-scroll';
import { checkIfRedirect, isObjectEmpty, isEmpty } from '../../utils';

const iamSmartBtnStyle = makeStyles((theme) =>({
    root: {
        borderRadius: 6,
        backgroundColor: theme.palette.iamSmart.main,
        color: theme.palette.common.white,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: theme.palette.iamSmart.main,
        }
    },
}))

const addressStyle = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column'
    }
})

export default withTranslation()(function PersonalInfo({t, ...rest}) {
    let scroll = Scroll.animateScroll;
    const iamSmartBtnClasses = iamSmartBtnStyle();
    const addressClasses = addressStyle();
    const { setValues, data } = useData();
    const history = useHistory();

    useEffect(() => {
        console.log("iAmSmart: " + process.env.REACT_APP_IAMSMART_DOMAIN)
        scroll.scrollToTop();
        
        if(prompt){
            prompt = false;
            if(document.referrer.includes(process.env.REACT_APP_IAMSMART_DOMAIN) && isObjectEmpty(data)){
                // 2024 Jan: read renewal data if applicant was renewing
                if(sessionStorage.getItem("renewalData") != null){
                    setValues(JSON.parse(sessionStorage.getItem("renewalData")));
                    sessionStorage.removeItem("renewalData");
                } else{
                    setValues({agreeTnc:true, applicationType:"New", applicantType:"Personal"})
                }

                iAMSmartRetrieveProfile();
            }else{
                checkIfRedirect(data, history);

                if(data.applicationType === "New" && data.iAMSmartFilled !== true){
                    iAMSmartRetrieveProfile();
                }
            }
        } else {
            checkIfRedirect(data, history);
        }
    }, [])

    function prepQR(lang){
        // 2024 Jan: set session storage to maintain renewal application info
        if(data.applicationType === "Renew"){
            if(data.iAMSmart?.access?.isDirectLogin === true){
                iAMSmartRetrieveProfile();
            }else{
                sessionStorage.setItem("renewalData", JSON.stringify(data));
                iAMSmartQR(lang);
            }
        }else{
            iAMSmartQR(lang);
        }
    }

    async function iAMSmartRetrieveProfile(){
        var access = null;
        var profile = null;

        if(getAuthCode()!=null){
            access = await iAMSmartToken(getAuthCode(), false);
            setValues({
                iAMSmart:{
                    access: {
                        accessToken: access?.accessToken,
                        openID: access?.openID,
                        issueAt: access?.issueAt,
                        expiresIn: access?.expiresIn
                    }
                }
            })
        }else{
            if(data.iAMSmart?.access?.isDirectLogin === true){
                access = {
                    accessToken: data.iAMSmart?.access?.accessToken,
                    openID: data.iAMSmart?.access?.openID,
                    issueAt: data.iAMSmart?.access?.issueAt,
                    expiresIn: data.iAMSmart?.access?.expiresIn
                }
            }
        }

        profile = await iAMSmartProfile(access?.accessToken, access?.openID);
        iAMSmartFilling(profile);
    }

    const schema = yup.object().shape({
        department: yup.string().when('applicantType', {
            is: val => val === 'Government',
            then: yup.string().required(t("errors.frontend.790-E-0235")),
            otherwise: yup.string().notRequired()
        }),
        personalTitle: yup.string().when('applicantType', {
            is: val => val === 'Personal' || isEmpty(val),
            then: yup.string().required(t("errors.frontend.790-E-0201")),
            otherwise: yup.string().notRequired()
        }),
        // lastName: yup.string().when('applicantType', {
        //     is: val => val === 'Personal',
        //     then: yup.string().required(t("errors.frontend.790-E-0202"))
        //         .test("non english letters", t("errors.frontend.790-E-0233") , (lastName)=>{
        //             const regex = new RegExp('^[a-zA-Z][a-zA-Z\\s]+$');
        //             return !lastName||regex.test(lastName);
        //         }),
        //     otherwise: yup.string().notRequired()
        // }),
        lastName: yup.string().notRequired(),
        firstName: yup.string().when('applicantType', {
            is: val => val === 'Personal' || isEmpty(val),
            then: yup.string().required(t("errors.frontend.790-E-0203"))
                .test("non english letters", t("errors.frontend.790-E-0236") , (firstName)=>{
                    const regex = new RegExp('^[a-zA-Z][a-zA-Z\\s]+$');
                    return !firstName||regex.test(firstName);
                }),
            otherwise: yup.string().notRequired()
        })
        .max(80, t("errors.frontend.790-E-0223")),
        // chinName: yup.string().notRequired().test("non chinese letters", t("errors.frontend.790-E-0234"), (chinName)=>{
        //     const regex = new RegExp('[^\u0000-\u007F]+');
        //     return !chinName||regex.test(chinName);
        // }),
        chinName: yup.string().notRequired(),
        contactTitle: yup.string().required(t("errors.frontend.790-E-0205")),
        contactPerson: yup.string().required(t("errors.frontend.790-E-0206"))
            .max(80, t("errors.frontend.790-E-0224")),
        telNo: yup.string().required(t("errors.frontend.790-E-0207"))
            .test("match tel rules", t("errors.frontend.790-E-0231"), (telNo)=>{
                const regex = new RegExp('[2,3,5,6,9]+[0-9]+');
                return !telNo||regex.test(telNo);
            })
            .max(8, t("errors.frontend.790-E-0209"))
            .test("min 8 digit", t("errors.frontend.790-E-0209"), (telNo)=>(!telNo||telNo.length==8))
            .matches(/^[0-9]+$/, t("errors.frontend.790-E-0208")),
        faxNo: yup.string().notRequired()
            .test("match fax rules", t("errors.frontend.790-E-0232"), (faxNo)=>{
                const regex = new RegExp('[2,3]+[0-9]+');
                return !faxNo||regex.test(faxNo);
            })
            .max(8, t("errors.frontend.790-E-0212"))
            .test("min 8 digit", t("errors.frontend.790-E-0212"), (faxNo)=>(!faxNo||faxNo.length==8))
            .matches(/^[0-9]*$/, t("errors.frontend.790-E-0211")),
        email: yup.string().email(t("errors.frontend.790-E-0214"))
        		.required(t("errors.frontend.790-E-0213"))
                .max(50, t("errors.frontend.790-E-0225")),
        reenterEmail: yup.string().email(t("errors.frontend.790-E-0214"))
        	.required(t("errors.frontend.790-E-0215"))
        	.oneOf([yup.ref('email'), null], t("errors.frontend.790-E-0216")),
        address: yup.string().notRequired()
        	.max(10, t("errors.frontend.790-E-0222")),
        floor: yup.string().notRequired()
            .max(10, t("errors.frontend.790-E-0222")),
        building: yup.string().when('applicantType', {
            is: val => val === 'Company' || val === 'Personal' || isEmpty(val),
            then: yup.string().required(t("errors.frontend.790-E-0219")),
            otherwise: yup.string().notRequired()
        }).max(60, t("errors.frontend.790-E-0222")),
        street: yup.string().when('applicantType', {
            is: val => val === 'Company' || val === 'Personal' || isEmpty(val),
            then: yup.string().required(t("errors.frontend.790-E-0220")),
            otherwise: yup.string().notRequired()
        }).max(60, t("errors.frontend.790-E-0222")),
        district: yup.string().when('applicantType', {
            is: val => val === 'Company' || val === 'Personal' || isEmpty(val),
            then: yup.string().required(t("errors.frontend.790-E-0230")),
            otherwise: yup.string().notRequired()
        }),
        companyName: yup.string().when('applicantType', {
            is: val => val === 'Company',
            then: yup.string().required(t("errors.frontend.790-E-0221")),
            otherwise: yup.string().notRequired()
        }).max(150, t("errors.frontend.790-E-0226"))
    })

    const {
        register,
        handleSubmit,
        control,
        errors,
        clearErrors,
        reset,
        watch,
        setValue,
        unregister,
        getValues
    } = useForm({
        defaultValues: {
            applicantType: data.applicantType || '',
            department: data.department || '',
            personalTitle: data.personalTitle || '',
            lastName: '',
            firstName: data.firstName || '',
            chinName: data.chinName || '',
            contactTitle: data.contactTitle || '',
            contactPerson: data.contactPerson || '',
            telNo: data.telNo || '',
            faxNo: data.faxNo || '',
            email: data.email || '',
            reenterEmail: data.reenterEmail || '',
            address: data.address || '',
            floor: data.floor || '',
            building: data.building || '',
            street: data.street || '',
            district: data.district || '',
            companyName: data.companyName || ''
        },
        mode: "onSubmit",
        resolver: useYupValidationResolver(schema),
    });
    
    // const formValues = getValues()
    // console.log('formvalues',formValues)
    console.log('data', data)
    const districtList = [
        "step3.location.Central_and_Western",
        "step3.location.Eastern",
        "step3.location.Southern",
        "step3.location.Wan_Chai",
        "step3.location.Sham_Shui_Po",
        "step3.location.Kowloon_City",
        "step3.location.Kwun_Tong",
        "step3.location.Wong_Tai_Sin",
        "step3.location.Yau_Tsim_Mong",
        "step3.location.Islands",
        "step3.location.Kwai_Tsing",
        "step3.location.North",
        "step3.location.Sai_Kung",
        "step3.location.Sha_Tin",
        "step3.location.Tai_Po",
        "step3.location.Tsuen_Wan",
        "step3.location.Tuen_Mun",
        "step3.location.Yuen_Long"
    ]
 
    const iasDistrict = {
		"CENTRAL & WESTERN DISTRICT":"Central and Western",
		"中西區":"Central and Western",
		"ADMIRALTY":"Central and Western",
		"金鐘":"Central and Western",
		"CENTRAL":"Central and Western",
		"中環":"Central and Western",
		"KENNEDY TOWN":"Central and Western",
		"堅尼地城":"Central and Western",
		"MID-LEVELS":"Central and Western",
		"半山":"Central and Western",
		"SHEUNG WAN":"Central and Western",
		"上環":"Central and Western",
		"SHEK TONG TSUI":"Central and Western",
		"石塘咀":"Central and Western",
		"SAI YING PUN":"Central and Western",
		"西營盤":"Central and Western",
		"THE PEAK":"Central and Western",
		"山頂":"Central and Western",
		"EASTERN DISTRICT":"Eastern",
		"東區":"Eastern",
		"CHAI WAN":"Eastern",
		"柴灣":"Eastern",
		"NORTH POINT":"Eastern",
		"北角":"Eastern",
		"QUARRY BAY":"Eastern",
		"鰂魚涌":"Eastern",
		"SHAU KEI WAN":"Eastern",
		"筲箕灣":"Eastern",
		"SAI WAN HO":"Eastern",
		"西灣河":"Eastern",
		"SOUTHERN DISTRICT":"Southern",
		"南區":"Southern",
		"ABERDEEN":"Southern",
		"香港仔":"Southern",
		"AP LEI CHAU":"Southern",
		"鴨脷洲":"Southern",
		"CHUNG HOM KOK":"Southern",
		"舂坎角":"Southern",
		"DEEP WATER BAY":"Southern",
		"深水灣":"Southern",
		"POK FU LAM":"Southern",
		"薄扶林":"Southern",
		"REPULSE BAY":"Southern",
		"淺水灣":"Southern",
		"SHEK O":"Southern",
		"石澳":"Southern",
		"STANLEY":"Southern",
		"赤柱":"Southern",
		"TAI TAM":"Southern",
		"大潭":"Southern",
		"WONG CHUK HANG":"Southern",
		"黃竹坑":"Southern",
		"WAN CHAI DISTRICT":"Wan Chai",
		"灣仔區":"Wan Chai",
		"CAUSEWAY BAY":"Wan Chai",
		"銅鑼灣":"Wan Chai",
		"HAPPY VALLEY":"Wan Chai",
		"跑馬仔":"Wan Chai",
		"TAI HANG":"Wan Chai",
		"大坑":"Wan Chai",
		"WAN CHAI":"Wan Chai",
		"灣仔":"Wan Chai",
		"KOWLOON CITY DISTRICT":"Kowloon City",
		"九龍城區":"Kowloon City",
		"HO MAN TIN":"Kowloon City",
		"何文田":"Kowloon City",
		"HUNG HOM":"Kowloon City",
		"紅磡":"Kowloon City",
		"KOWLOON CITY":"Kowloon City",
		"九龍城":"Kowloon City",
		"KOWLOON TONG":"Kowloon City",
		"九龍塘":"Kowloon City",
		"MA TAU WAI":"Kowloon City",
		"馬頭圍":"Kowloon City",
		"TO KWA WAN":"Kowloon City",
		"土瓜灣":"Kowloon City",
		"KWUN TONG DISTRICT":"Kwun Tong",
		"觀塘區":"Kwun Tong",
		"CHA KWO LING":"Kwun Tong",
		"茶果嶺":"Kwun Tong",
		"KOWLOON BAY":"Kwun Tong",
		"九龍灣":"Kwun Tong",
		"KWUN TONG":"Kwun Tong",
		"觀塘":"Kwun Tong",
		"LAM TIN":"Kwun Tong",
		"藍田":"Kwun Tong",
		"NGAU TAU KOK":"Kwun Tong",
		"牛頭角":"Kwun Tong",
		"SAU MAU PING":"Kwun Tong",
		"秀茂坪":"Kwun Tong",
		"YAU TONG ":"Kwun Tong",
		"油塘":"Kwun Tong",
		"SHAM SHUI PO DISTRICT":"Kwun Tong",
		"深水埗區":"Sham Shui Po",
		"CHEUNG SHA WAN":"Sham Shui Po",
		"長沙灣":"Sham Shui Po",
		"LAI CHI KOK":"Sham Shui Po",
		"荔枝角":"Sham Shui Po",
		"MEI FOO":"Sham Shui Po",
		"美孚":"Sham Shui Po",
		"SHEK KIP MEI":"Sham Shui Po",
		"石硤尾":"Sham Shui Po",
		"SHAM SHUI PO":"Sham Shui Po",
		"深水埗":"Sham Shui Po",
		"TAI KOK TSUI":"Sham Shui Po",
		"大角咀":"Sham Shui Po",
		"YAU YAT CHUEN":"Sham Shui Po",
		"又一村":"Sham Shui Po",
		"WONG TAI SIN DISTRICT":"Sham Shui Po",
		"黃大仙區":"Wong Tai Sin",
		"CHOI HUNG":"Wong Tai Sin",
		"彩虹":"Wong Tai Sin",
		"DIAMOND HILL":"Wong Tai Sin",
		"鑽石山":"Wong Tai Sin",
		"LOK FU":"Wong Tai Sin",
		"樂富":"Wong Tai Sin",
		"NGAU CHI WAN":"Wong Tai Sin",
		"牛池灣":"Wong Tai Sin",
		"SAN PO KONG":"Wong Tai Sin",
		"新蒲崗":"Wong Tai Sin",
		"TSZ WAN SHAN":"Wong Tai Sin",
		"慈雲山":"Wong Tai Sin",
		"WANG TAU HOM":"Wong Tai Sin",
		"橫頭磡":"Wong Tai Sin",
		"WONG TAI SIN":"Wong Tai Sin",
		"黃大仙":"Wong Tai Sin",
		"YAU TSIM MONG DISTRICT":"Yau Tsim Mong",
		"油尖旺區":"Yau Tsim Mong",
		"JORDAN":"Yau Tsim Mong",
		"佐敦":"Yau Tsim Mong",
		"MONG KOK":"Yau Tsim Mong",
		"旺角":"Yau Tsim Mong",
		"TSIM SHA TSUI":"Yau Tsim Mong",
		"尖沙咀":"Yau Tsim Mong",
		"YAU MA TEI":"Yau Tsim Mong",
		"油麻地":"Yau Tsim Mong",
		"ISLANDS DISTRICT":"Islands",
		"離島區":"Islands",
		"CHEUNG CHAU":"Islands",
		"長洲":"Islands",
		"CHEUNG SHA LANTAU ISLAND":"Islands",
		"大嶼山長沙":"Islands",
		"CHEK LAP KOK LANTAU ISLAND":"Islands",
		"大嶼山赤鱲角":"Islands",
		"CHI MA WAN LANTAU ISLAND":"Islands",
		"大嶼山芝麻灣":"Islands",
		"DISCOVERY BAY LANTAU ISLAND":"Islands",
		"大嶼山愉景灣":"Islands",
		"HEI LING CHAU":"Islands",
		"喜靈洲":"Islands",
		"LANTAU ISLAND":"Islands",
		"大嶼山":"Islands",
		"LAMMA ISLAND":"Islands",
		"南丫島":"Islands",
		"MUI WO LANTAU ISLAND":"Islands",
		"大嶼山梅窩":"Islands",
		"NGONG PING LANTAU ISLAND":"Islands",
		"大嶼山昂坪":"Islands",
		"PENG CHAU":"Islands",
		"坪洲":"Islands",
		"SHEK PIK LANTAU ISLAND":"Islands",
		"大嶼山石壁":"Islands",
		"TAI O LANTAU ISLAND":"Islands",
		"大嶼山大澳":"Islands",
		"TONG FUK LANTAU ISLAND":"Islands",
		"大嶼山塘福":"Islands",
		"TUNG CHUNG LANTAU ISLAND":"Islands",
		"大嶼山東涌":"Islands",
		"KWAI TSING DISTRICT":"Kwai Tsing",
		"葵青區":"Kwai Tsing",
		"KWAI CHUNG":"Kwai Tsing",
		"葵涌":"Kwai Tsing",
		"TSING YI":"Kwai Tsing",
		"青衣":"Kwai Tsing",
		"NORTH DISTRICT":"North",
		"北區":"North",
		"FANLING":"Kwai Tsing",
		"粉嶺":"Kwai Tsing",
		"KWAN TEI FANLING":"Kwai Tsing",
		"粉嶺軍地":"Kwai Tsing",
		"KWU TUNG":"Kwai Tsing",
		"古洞":"Kwai Tsing",
		"PING CHE":"Kwai Tsing",
		"坪輋":"Kwai Tsing",
		"SHEUNG SHUI":"Kwai Tsing",
		"上水":"Kwai Tsing",
		"SHA TAU KOK":"Kwai Tsing",
		"沙頭角":"Kwai Tsing",
		"TA KWU LING":"Kwai Tsing",
		"打鼓嶺":"Kwai Tsing",
		"SAI KUNG DISTRICT":"Sai Kung",
		"西頁區":"Sai Kung",
		"CLEAR WATER BAY":"Sai Kung",
		"清水灣":"Sai Kung",
		"HANG HAU SAI KUNG":"Sai Kung",
		"西頁坑口":"Sai Kung",
		"SAI KUNG ":"Sai Kung",
		"西頁":"Sai Kung",
		"TSEUNG KWAN O":"Sai Kung",
		"將軍澳":"Sai Kung",
		"SHA TIN DISTRICT":"Sha Tin",
		"沙田區":"Sha Tin",
		"FO TAN SHA TIN":"Sha Tin",
		"沙田火炭":"Sha Tin",
		"KAU TO SHAN":"Sha Tin",
		"九肚山":"Sha Tin",
		"MA LIU SHUI":"Sha Tin",
		"馬料水":"Sha Tin",
		"MA ON SHAN":"Sha Tin",
		"馬鞍山":"Sha Tin",
		"SHA TIN":"Sha Tin",
		"沙田":"Sha Tin",
		"SIU LEK YUEN SHA TIN":"Sha Tin",
		"沙田小瀝源":"Sha Tin",
		"TAI WAI SHA TIN":"Sha Tin",
		"沙田大圍":"Sha Tin",
		"TUEN MUN DISTRICT":"Tuen Mun",
		"屯門區":"Tuen Mun",
		"FU TEI TUEN MUN":"Tuen Mun",
		"屯門虎地":"Tuen Mun",
		"LAM TEI TUEN MUN":"Tuen Mun",
		"屯門藍地":"Tuen Mun",
		"SAN HUI TUEN MUN":"Tuen Mun",
		"屯門新墟":"Tuen Mun",
		"SIU LAM TUEN MUN":"Tuen Mun",
		"屯門小欖":"Tuen Mun",
		"SO KWUN WAT":"Tuen Mun",
		"掃管笏":"Tuen Mun",
		"TAI LAM":"Tuen Mun",
		"大欖":"Tuen Mun",
		"TUEN MUN":"Tuen Mun",
		"屯門":"Tuen Mun",
		"TAI PO DISTRICT":"Tai Po",
		"大埔區":"Tai Po",
		"LAM TSUEN TAI PO":"Tai Po",
		"大埔林村":"Tai Po",
		"SHUEN WAN TAI PO":"Tai Po",
		"大埔船灣":"Tai Po",
		"TAI PO":"Tai Po",
		"大埔":"Tai Po",
		"TAI WO":"Tai Po",
		"太和":"Tai Po",
		"TING KOK TAI PO":"Tai Po",
		"大埔汀角":"Tai Po",
		"TAI PO KAU":"Tai Po",
		"大埔滘":"Tai Po",
		"TSUEN WAN DISTRICT":"Tsuen Wan",
		"荃灣區":"Tsuen Wan",
		"LO WAI TSUEN WAN":"Tsuen Wan",
		"荃灣老圍":"Tsuen Wan",
		"MA WAN":"Tsuen Wan",
		"馬灣":"Tsuen Wan",
		"SHAM TSENG":"Tsuen Wan",
		"深井":"Tsuen Wan",
		"TING KAU":"Tsuen Wan",
		"汀九":"Tsuen Wan",
		"TSEUN WAN":"Tsuen Wan",
		"荃灣":"Tsuen Wan",
		"YUEN LONG DISTRICT":"Tsuen Wan",
		"元朗區":"Yuen Long",
		"HA TSUEN YUEN LONG":"Yuen Long",
		"元朗廈村":"Yuen Long",
		"HUNG SHUI KIU":"Yuen Long",
		"洪水橋":"Yuen Long",
		"KAM TIN YUEN LONG":"Yuen Long",
		"元朗錦田":"Yuen Long",
		"LAU FAU SHAN":"Yuen Long",
		"流浮山":"Yuen Long",
		"PAT HEUNG YUEN LONG":"Yuen Long",
		"元朗八鄉":"Yuen Long",
		"PING SHAN YUEN LONG":"Yuen Long",
		"元朗屏山":"Yuen Long",
		"SAN TIN YUEN LONG":"Yuen Long",
		"元朗新田":"Yuen Long",
		"SHEK KONG YUEN LONG":"Yuen Long",
		"元朗石崗":"Yuen Long",
		"TAM MEI YUEN LONG":"Yuen Long",
		"元朗潭尾":"Yuen Long",
		"TIN SHUI WAI":"Yuen Long",
		"天水圍":"Yuen Long",
		"TAI TONG YUEN LONG":"Yuen Long",
		"元朗大棠":"Yuen Long",
		"YUEN LONG":"Yuen Long",
		"元朗":"Yuen Long"
    };

    console.log('error', errors)
    const onSubmit = (data) => {
        const { applicantType, ...rest } = data;
        console.log("rest", rest);
        setValues(rest);
        history.push(`${process.env.REACT_APP_SUB_ROUTE}/DateTimeDetail`);
    };

    const onError = (errors) => {
        scroll.scrollToTop();
    }

    const handleReset = () => {
        scroll.scrollToTop();
        console.log('getValues():', getValues())
        const emptyFields = [
            "personalTitle",
            "lastName",
            "firstName",
            "chinName",
            "contactTitle",
            "contactPerson",
            "telNo",
            "faxNo",
            "email",
            "reenterEmail",
            "address",
            "floor",
            "building",
            "street",
            "district"
        ]
        emptyFields.forEach((field)=>{
            setValue(field, '');
        })
        resetiamSmart();
    	clearErrors();	
    };
    
    const titles = {
    	"Mr":"mr",	
    	"Mrs":"mrs",	
    	"Ms":"ms",	
    	"Miss":"miss"	
    };
	
    const titlesMap = [
    		"t('common.selectChoose')",
            "t('step2.personalInfo.titleInfo.mr')",
            "t('step2.personalInfo.titleInfo.mrs')",
            "t('step2.personalInfo.titleInfo.ms')",
            "t('step2.personalInfo.titleInfo.miss')"
    ]
    
	const resetiamSmart = () => {
		let iamSmartField = document.querySelectorAll("[id$='_iamSmartFilled']");
		iamSmartField.forEach((field) => {
			document.getElementById(field.id).hidden=true;
		});
	}

    const handleBack = () => {
        setValues({iAMSmartFilled: false});

        if ((data.applicationType === 'New')&&data.applicantType!=="Government") history.push("./particularsApplicant");
        else history.push(`${process.env.REACT_APP_SUB_ROUTE}/selectService`);
    }

    var prompt = true;

    const getAuthCode = () => {
    	const queryString = window.location.search;
    	const urlParams = new URLSearchParams(queryString);
    	const code = urlParams.get('code')
    	return code;
    }

	
	const iAMSmartFilling = (profile) => {
        if(profile == null || profile == undefined) {
            return;
		}
        setValues({iAMSmartFilled: true});

        var json = iAMSmartProfileTransform(profile)
		console.log("Filling json");
		console.log(json);

		if(json["UnstructuredName"] != "") {
            setValue('firstName', json["UnstructuredName"].replace(',', ''));
			document.getElementById("firstName_iamSmartFilled").hidden=false;
            setValue('contactPerson', json["UnstructuredName"].replace(',', ''));
			document.getElementById("contactPerson_iamSmartFilled").hidden=false;
        }
        if(json["SubscriberNumber"] != "") {
            setValue('telNo', json["SubscriberNumber"]);
			document.getElementById("telNo_iamSmartFilled").hidden=false;
        }
        if (json["prefix"] == "Mr" || json["prefix"] == "Mrs" || json["prefix"] == "Ms" || json["prefix"] == "Miss" ) {
            setValue('personalTitle', titles[json["prefix"]]);
            setValue('contactTitle', titles[json["prefix"]]);
			document.getElementById("personalTitle_iamSmartFilled").hidden=false;
			document.getElementById("contactTitle_iamSmartFilled").hidden=false;
        }
        if(json["emailAddress"] != "") {
            setValue('email', json["emailAddress"]);
			document.getElementById("email_iamSmartFilled").hidden=false;
	        setValue('reenterEmail', json["emailAddress"]);
			document.getElementById("reenterEmail_iamSmartFilled").hidden=false;
        }
        if(json["EngUnitNo"] != "" ) {
            setValue('address', json["EngUnitNo"]);
			document.getElementById("address_iamSmartFilled").hidden=false;
        }else if(json["ChiUnitNo"] != "" ) {
            setValue('address', json["ChiUnitNo"]);
			document.getElementById("address_iamSmartFilled").hidden=false;
        }
        if(json["EngFloorNum"] != "") {
            setValue('floor', json["EngFloorNum"]);
			document.getElementById("floor_iamSmartFilled").hidden=false;
        }else if(json["ChiFloorNum"] != "") {
            setValue('floor', json["ChiFloorNum"]);
			document.getElementById("floor_iamSmartFilled").hidden=false;
        }
        if (json["EngBuildingName"] != "" || json["EngEstateName"] != "") {
            if (json["EngBuildingName"] != "" && json["EngEstateName"] != "") {
                setValue('building', json["EngBlockDescriptor"] + " " + json["EngBlockNo"] + ", " + json["EngBuildingName"] + ", " + json["EngPhaseNo"] + " " + json["EngEstateName"]);
            } else if (json["EngBuildingName"] != "") {
                setValue('building', json["EngBuildingName"]);
            } else {
                setValue('building', json["EngEstateName"]);
            }
			document.getElementById("building_iamSmartFilled").hidden=false;
        } else if (json["ChiBuildingName"] != "" || json["ChiEstateName"] != "") {
            const building = (isEmpty(json["ChiEstateName"])?"":json["ChiEstateName"]) + (isEmpty(json["ChiPhaseNo"])?"":`${json["ChiPhaseNo"]}期`) + json["ChiBuildingName"] + json["ChiBlockNo"] + json["ChiBlockDescriptor"];
            setValue('building', building );
			document.getElementById("building_iamSmartFilled").hidden=false;
        }
        if (json["EngBuildingNoFrom"] != "" || json["EngStreetName"] != "") {
            if (json["EngBuildingNoFrom"] != "") {
                setValue('street', json["EngBuildingNoFrom"] + " " + json["EngStreetName"]);
            }else{
                setValue('street', json["EngStreetName"]);
            }
			document.getElementById("street_iamSmartFilled").hidden=false;
        } else if (json["ChiBuildingNoFrom"] != "" || json["ChiStreetName"] != "") {
            setValue('street', json["ChiStreetName"] + (isEmpty(json["ChiBuildingNoFrom"])?"":`${json["ChiBuildingNoFrom"]}號`));
			document.getElementById("street_iamSmartFilled").hidden=false;
        }
        if (json["EngSub-district"] != "") {
            setValue('district', iasDistrict[json["EngSub-district"]]);
			document.getElementById("district_iamSmartFilled").hidden=false;
        }else if(json["ChiSub-district"] != "") {
            setValue('district', iasDistrict[json["ChiSub-district"]]);
			document.getElementById("district_iamSmartFilled").hidden=false;
        }
		document.getElementById("filled_iamSmartFilled").hidden=false;
    }
	
	const modified = (element) => {
		console.log(element)
		if(element == "district" || element == "personalTitle" || element == "contactTitle") {
			document.getElementById(element+"_iamSmartFilled").hidden=true;
			console.log(data);
		} else if (element.target.id == "address" || element.target.id == "floor" || element.target.id == "building" || element.target.id == "street"){
			document.getElementById("address_iamSmartFilled").hidden=true;
			document.getElementById("floor_iamSmartFilled").hidden=true;
			document.getElementById("building_iamSmartFilled").hidden=true;
			document.getElementById("street_iamSmartFilled").hidden=true;
		} else {
			document.getElementById(element.target.id+"_iamSmartFilled").hidden=true;
		}
	}

    const [contactSameWithApplicant, setContactSameWithApplicant] = useState(false);

    const handleContactSameWithApplicantChange = (event)=>{
        setContactSameWithApplicant(event.target.checked);
        if(event.target.checked){
            setValue("contactTitle", watch("personalTitle"));
            setValue("contactPerson", watch("firstName"));
        }
    }
    
    const [dnsData, setDnsData] = useState(null);

    const getDnsData = async () => {
    const response = await fetch(`https://dns.google.com/resolve?name=` + window.location.hostname + `&type=1`);
    const jsonData = await response.json();
        return jsonData;
    };

    useEffect(() => {
        getDnsData().then(data => {
        setDnsData(data);
        }); 
    }, []);

    if (dnsData === null) {
        return null;
    }
    
    console.log("<><><><>Host:", window.location.hostname.split('.')[0]);
    console.log("<><><><>IP:", window.location.origin);
    
    const siteID = () => {
        console.log("DNS Status Code: ", dnsData.Status);
        if (dnsData.Status.toString() === "0") {
            if(dnsData.Answer[0].data.toString() === "202.128.244.150") {
                console.log(">>> UAT <<<");
                return "0";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.229.85") {
                console.log(">>> KP Server <<<");
                return "1";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.244.85") {
                console.log(">>> SP Server <<<");
                return "2";
            }
            else if (dnsData.Answer[0].name.toString() === "epas.td.gov.hk.") {
                if (dnsData.Answer[1].data.toString() === "202.128.229.85") {
                    console.log(">>> KP Server <<<");
                    return "1";
                }
                else if (dnsData.Answer[1].data.toString() === "202.128.244.85") {
                    console.log(">>> SP Server <<<");
                    return "2";
                }
            }
        }
        else {
            console.log(">>> Localhost <<<");
            return "0";
        }
    }
    
    return (
        <main>
            <Helmet>
                <title>{`Screen ID: SC-790-`+siteID()+'-003'}</title>
            </Helmet>
            <div className="personalInfo">
                <Box className="wrapper personalInfo">
                    <Header langLock="langLocked" />
                    <Box className="mainWrapper">
                        <Navbar step="step2" />
                        <Box className="contentWrapper">
                            <ErrorsContainer errors={errors} />
                            <StepHeader
                                step="common.step2"
                                title="common.step2Title"
                                mandatory
                            />
                            <form onSubmit={handleSubmit(onSubmit, onError)} noValidate>
                                <input
                                    name="applicantType"
                                    ref={register}
                                    hidden
                                />

                                <FormControl>
                                    <BootstrapInput
                                        name="siteIDNumber"
                                        id="siteIDNumber"
                                        hidden
                                        value={siteID()}
                                        inputRef={register}
                                    />
                                </FormControl>
                                    {/* data.applicantType === 'Personal' && */}
                                {
                                    ((data.applicantType !== 'Government') && (data.applicantType !== 'Company') && 
                                    (!(data.applicationType === "New" && data.iAMSmart?.access?.isDirectLogin === true))
                                    ) &&
                                    <FormBox header="step2.iamSmart.title">
                                        <Box p={5}>
                                            <Typography variant="body1" className="formBoxDesc">
                                                {t('step2.iamSmart.desc1')}
                                            </Typography>
                                            <Grid container spacing={4}>
                                                <Grid item>
                                                    <Button
                                                        variant="contained"
                                                        classes={{root: iamSmartBtnClasses.root}}
                                                        startIcon={
                                                            <img className="iamSmartPhone" src={iamSmartPhone} alt="" />
                                                        }
                                                        className="iamSmartButton"
                                                        onClick={() => prepQR(t('step2.iamSmart.lang'))}
                                                    >
                                                        <div style={{fontSize: "12px"}}>{t('common.button.iamSmartFilling')}</div>
                                                    </Button>
                                                </Grid>
                                                <Grid item>
    	                                            <a style={{fontSize: "12px"}} className="iamSmartMore" href={t('step2.iamSmart.link')} target="_blank">{t('step2.iamSmart.more')}</a>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </FormBox>
                                }
                                {
                                    data.applicantType === 'Government' ?
                                        <FormBox header="step2.governmentInfo.title">
                                            <Box p={5}>
                                                <Box mb={6}>
                                                    <FormControl
                                                        error={!!errors.department}
                                                    >
                                                        <InputLabel shrink id="department">
                                                            {t('step2.governmentInfo.department')} <Box component="span" className="danger">*</Box>
                                                        </InputLabel>
                                                        <Controller
                                                            control={control}
                                                            name='department'
                                                            defaultValue={getValues('department')}
                                                            render={(props)=>
                                                            (<Select
                                                                labelId="department"
                                                                inputProps={{ 
																	"aria-labelledby": "department"
																}}
                                                                value={props.value}
                                                                onChange={props.onChange}
                                                                displayEmpty
                                                            >
                                                                {Object.getOwnPropertyNames(t("common.governmentDepartment", { returnObjects: true })).sort().map((departmentCode)=>(
                                                                    <MenuItem value={departmentCode}>{`${t(`common.governmentDepartment.${departmentCode}`)} (${departmentCode})`}</MenuItem>
                                                                ))}
                                                            </Select>)
                                                        }/>
                                                    </FormControl>
                                                </Box>
                                            </Box>
                                        </FormBox>
                                        :
                                        data.applicantType === 'Company' ?
                                            <FormBox header="step2.companyInfo.title">
                                                <Box p={5}>
                                                    <Box mb={6}>
                                                        <FormControl
                                                            error={!!errors.companyName}
                                                        >
                                                            <InputLabel shrink htmlFor="companyName">
                                                                {t('step2.companyInfo.companyName')} <Box component="span" className="danger">*</Box>
                                                                {!!errors.companyName ? <img id="companyName_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                            </InputLabel>
                                                            <BootstrapInput
                                                                name="companyName"
                                                                id="companyName"
                                                                inputProps={{ 
                                                                    "aria-labelledby": "companyName",
                                                                    "maxlength": "150"
                                                                }}
                                                                //defaultValue={data.companyName}
                                                                inputRef={register}
                                                            />
                                                        </FormControl>
                                                    </Box>
                                                </Box>
                                            </FormBox>
                                        :
                                        <FormBox header="step2.personalInfo.title">
                                            <Box p={5}>
                                                <Box mb={6}>
                                                    <FormControl
                                                        error={!!errors.personalTitle}
                                                    >
                                                        <InputLabel shrink id="personalTitle">
                                                            {t('step2.personalInfo.titleField')} <Box component="span" className="danger">*</Box>
                                                        </InputLabel>
                                                        <div className="row">
    	                                                    <Controller
    	                                                        control={control}
    	                                                        name="personalTitle"
                                                                id="personalTitleInput"
    	                                                        //defaultValue={data.personalTitle ? data.personalTitle : ''}
                                                                render={(props)=>
                                                                (<Select
                                                                    labelId="personalTitle"
                                                                    value={props.value}
                                                                    onChange={(event)=>{
                                                                    	modified(props.name);
                                                                        if(contactSameWithApplicant){
                                                                            setValue("contactTitle", event.target.value);
                                                                        }
                                                                    	props.onChange(event.target.value);
                                                                    }}
                                                                    displayEmpty
                                                                    inputProps={{ 
                                                                        "aria-labelledby": "personalTitle" 
                                                                    }}
                                                                >
	    	                                                        <MenuItem value="">{t('common.selectChoose')}</MenuItem>
	    	                                                        <MenuItem value="mr">{t('step2.personalInfo.titleInfo.mr')}</MenuItem>
	    	                                                        <MenuItem value="mrs">{t('step2.personalInfo.titleInfo.mrs')}</MenuItem>
	    	                                                        <MenuItem value="ms">{t('step2.personalInfo.titleInfo.ms')}</MenuItem>
                                                                    <MenuItem value="miss">{t('step2.personalInfo.titleInfo.miss')}</MenuItem>
                                                                </Select>)
                                                                }
    	                                                    />
    	                                                    <img hidden id="personalTitle_iamSmartFilled" className="iamSmartFilled" src={iamSmartFilled} alt="" />
    	                                                    {!!errors.personalTitle ? <img id="personalTitle_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
    	                                                </div>
                                                    </FormControl>
                                                </Box>
                                                <input type="hidden" name="lastName" value="" ref={register()}/>
                                                <input type="hidden" name="chinName" value="" ref={register()}/>
                                                <Box mb={6}>
                                                    <FormControl
                                                        error={!!errors.firstName}
                                                    >
                                                        <InputLabel shrink htmlFor="firstName">
                                                            {t('step2.personalInfo.firstName')} <Box component="span" className="danger">*</Box>
                                                        </InputLabel>
                                                        <div className="row">
    	                                                    <BootstrapInput
    	                                                        name="firstName"
                                                                id="firstName"
                                                                inputProps={{ 
                                                                    "aria-labelledby": "firstName",
                                                                    "maxlength": "80"
                                                                }}
    	                                                        //defaultValue={data.firstName}
    	                                                        inputRef={register}
    	                                                		onChange={(e)=>{
                                                                    modified(e);
                                                                    if(contactSameWithApplicant){
                                                                        setValue("contactPerson", e.target.value);
                                                                    }
                                                                }}
    	                                                	/>
    	                                                	<img hidden id="firstName_iamSmartFilled" className="iamSmartFilled" src={iamSmartFilled} alt="" />
    	                                                	{!!errors.firstName ? <img id="firstName_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
    	                                                </div>
                                                    </FormControl>
                                                </Box>
                                            </Box>
                                        </FormBox>
                                }

                                <FormBox header="step2.contactInfo.title">
                                    <Box p={5}>
                                        {
                                        (isEmpty(watch("applicantType")) || watch("applicantType")==="Personal") && 
                                        <Box mb={6}>
                                        <FormControlLabel
                                            control={<Checkbox checked={contactSameWithApplicant} onChange={handleContactSameWithApplicantChange} />}
                                            label={t("step2.contactInfo.sameWithApplicant")}
                                        />
                                        </Box>
                                        }
                                        <Box mb={6}>
                                            <FormControl
                                                error={!!errors.contactTitle}
                                            >
                                                <InputLabel shrink id="contactTitle">
                                                    {t('step2.contactInfo.titleField')} <Box component="span" className="danger">*</Box>
                                                </InputLabel>
                                                <div className="row">
    	                                            <Controller
    	                                                control={control}
    	                                                name="contactTitle"
                                                        id="contactTitleInput"
    	                                                //defaultValue={data.contactTitle ? data.contactTitle : ''}
                                                        render={(props)=>
                                                        (<Select
                                                            readOnly={contactSameWithApplicant}
                                                            className={contactSameWithApplicant?"ReadOnly":""}
                                                            labelId="contactTitle"
                                                            value={props.value}
                                                            onChange={(event)=>{
                                                            	modified(props.name);
                                                            	props.onChange(event.target.value);
                                                            }}
                                                            displayEmpty
                                                            inputProps={{ 
                                                                "aria-labelledby": "contactTitle" 
                                                            }}
                                                        >
	                                                        <MenuItem value="">{t('common.selectChoose')}</MenuItem>
	                                                        <MenuItem value="mr">{t('step2.personalInfo.titleInfo.mr')}</MenuItem>
                                                            <MenuItem value="mrs">{t('step2.personalInfo.titleInfo.mrs')}</MenuItem>
                                                            <MenuItem value="ms">{t('step2.personalInfo.titleInfo.ms')}</MenuItem>
                                                            <MenuItem value="miss">{t('step2.personalInfo.titleInfo.miss')}</MenuItem>
                                                        </Select>)
                                                        }
    	                                            />
    	                                            <img hidden id="contactTitle_iamSmartFilled" className="iamSmartFilled" src={iamSmartFilled} alt="" />
    	                                            {!!errors.contactTitle ? <img id="contactTitle_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                </div>
                                            </FormControl>
                                        </Box>
                                        <Box mb={6}>
                                            <FormControl
                                                error={!!errors.contactPerson}
                                            >
                                                <InputLabel shrink htmlFor="contactPerson">
                                                    {t('step2.contactInfo.contactPerson')} <Box component="span" className="danger">*</Box>
                                                </InputLabel>
                                                <div className="row">
    	                                            <BootstrapInput
    	                                                name="contactPerson"
                                                        id="contactPerson"
                                                        className={contactSameWithApplicant?"ReadOnly":""}
    	                                                //defaultValue={data.contactPerson}
    	                                                inputRef={register}
                                                        inputProps={{ 
                                                            "readOnly": contactSameWithApplicant,
                                                            "aria-labelledby": "contactPerson",
                                                            "maxlength": "80" 
                                                        }}
    	                                        		onChange={modified.bind(this)}
    	                                        	/>
    	                                        	<img hidden id="contactPerson_iamSmartFilled" className="iamSmartFilled" src={iamSmartFilled} alt="" />
    	                                        	{!!errors.contactPerson ? <img id="contactPerson_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                </div>
                                            </FormControl>
                                        </Box>
                                        <Box mb={6}>
                                            <FormControl
                                                error={!!errors.telNo}
                                            >
                                                <InputLabel shrink htmlFor="telNo">
                                                    {t('step2.contactInfo.telNo')} <Box component="span" className="danger">*</Box>
                                                </InputLabel>
                                                <div className="row">
    	                                            <BootstrapInput
    	                                                name="telNo"
                                                        id="telNo"
    	                                                //defaultValue={data.telNo}
    	                                                inputRef={register}
                                                        inputProps={{ 
                                                            "aria-labelledby": "telNo",
                                                            "maxlength": "15" 
                                                        }}
    	                                        		onChange={modified.bind(this)}
    	                                        	/>
    	                                        	<img hidden id="telNo_iamSmartFilled" className="iamSmartFilled" src={iamSmartFilled} alt="" />
    	                                        	{!!errors.telNo ? <img id="telNo_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                </div>
                                            </FormControl>
                                        </Box>
                                        <Box mb={6}>
                                            <FormControl
                                                error={!!errors.faxNo}
                                            >
                                                <InputLabel shrink htmlFor="faxNo">
                                                    {t('step2.contactInfo.faxNo')}
                                                </InputLabel>
                                                <div className="row">
    	                                            <BootstrapInput
    	                                                name="faxNo"
                                                        id="faxNo"
                                                        inputProps={{ 
                                                            "aria-labelledby": "faxNo",
                                                            "maxlength": "15"
                                                        }}
    	                                                //defaultValue={data.faxNo}
    	                                                inputRef={register}
    	                                            />
    	                                            <img hidden id="faxNo_iamSmartFilled" className="iamSmartFilled" src={iamSmartFilled} alt="" />
    	                                            {!!errors.faxNo ? <img id="faxNo_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
    	                                        </div>
                                            </FormControl>
                                        </Box>
                                        <Box mb={6}>
                                            <FormControl
                                                error={!!errors.email}
                                            >
                                                <InputLabel shrink htmlFor="email">
                                                    {t('step2.contactInfo.email')} <Box component="span" className="danger">*</Box>
                                                </InputLabel>
                                                <div className="row">
    	                                            <BootstrapInput
    	                                                name="email"
                                                        id="email"
    	                                                //defaultValue={data.email}
    	                                                inputRef={register}
                                                        inputProps={{ 
                                                            "aria-labelledby": "email",
                                                            "maxlength": "50"
                                                        }}
    	                                        		onChange={modified.bind(this)}
    	                                        	/>
    	                                        	<img hidden id="email_iamSmartFilled" className="iamSmartFilled" src={iamSmartFilled} alt="" />
    	                                        	{!!errors.email ? <img id="email_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
    	                                        </div>
                                            </FormControl>
                                        </Box>
                                        <Box mb={6}>
                                            <FormControl
                                                error={!!errors.reenterEmail}
                                            >
                                                <InputLabel shrink htmlFor="reenterEmail">
                                                    {t('step2.contactInfo.reenterEmail')} <Box component="span" className="danger">*</Box>
                                                </InputLabel>
                                                <div className="row">
    	                                            <BootstrapInput
    	                                                name="reenterEmail"
                                                        id="reenterEmail"
    	                                                //defaultValue={data.reenterEmail}
    	                                                inputRef={register}
                                                        inputProps={{ 
                                                            "aria-labelledby": "reenterEmail",
                                                            "maxlength": "50"
                                                        }}
    	                                        		onChange={modified.bind(this)}
    	                                        	/>
    	                                        	<img hidden id="reenterEmail_iamSmartFilled" className="iamSmartFilled" src={iamSmartFilled} alt="" />
    	                                        	{!!errors.reenterEmail ? <img id="reenterEmail_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
    	                                        </div>
                                            </FormControl>
                                        </Box>
                                        {data.applicantType !== 'Government' &&
                                        <Box mb={6}
                                            classes={{root: addressClasses.root}}
                                        >
                                            <FormControl
                                                error={!!errors.address}
                                            >
                                                <InputLabel shrink htmlFor="address">
                                                    {t('step2.contactInfo.address')} 
                                                    {data.applicantType == 'Government' ? <div></div> : <Box component="span" className="danger">*</Box>}
                                                </InputLabel>
                                                <div className="row">
    	                                            <BootstrapInput
    	                                                name="address"
                                                        id="address"
    	                                                //defaultValue={data.address}
    	                                                inputRef={register}
    	                                                placeholder={t('step2.contactInfo.flatRm') + " (" + t('step2.contactInfo.eg') + "A3 / 5A)"}
                                                        inputProps={{ 
                                                            "aria-labelledby": "address",
                                                            "maxlength": "10"
                                                        }}
    	                                        		onChange={modified.bind(this)}
    	                                        	/>
    	                                        	<img hidden id="address_iamSmartFilled" className="iamSmartFilled" src={iamSmartFilled} alt="" />
    	                                        	{!!errors.address ? <img id="address_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
    	                                        </div>
                                            </FormControl>
                                            <FormControl
                                                error={!!errors.floor}
                                            >
    	                                        <div className="row">
    	                                            <BootstrapInput
    	                                                name="floor"
                                                        id="floor"
    	                                                //defaultValue={data.floor}
    	                                                inputRef={register}
    	                                                placeholder={t('step2.contactInfo.floor') + " (" + t('step2.contactInfo.eg') + "6)"}
    	                                        		onChange={modified.bind(this)}
                                                        inputProps={{ 
                                                            "aria-labelledby": "floor",
                                                            "maxlength": "10"
                                                        }}
    	                                        	/>
    	                                        	<img hidden id="floor_iamSmartFilled" className="iamSmartFilled" src={iamSmartFilled} alt="" />
    	                                        	{!!errors.floor ? <img id="floor_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
    	                                        </div>
                                            </FormControl>
                                            <FormControl
                                                error={!!errors.building}
                                            >
    	                                        <div className="row">
    	                                            <BootstrapInput
    	                                                name="building"
                                                        id="building"
    	                                                //defaultValue={data.building}
    	                                                inputRef={register}
    	                                                placeholder={t('step2.contactInfo.building') + " (" + t('step2.contactInfo.eg') + t('step2.contactInfo.egBuilding') + ")"}
    		                                    		onChange={modified.bind(this)}
                                                        inputProps={{ 
                                                            "aria-labelledby": "building",
                                                            "maxlength": "60"
                                                        }}
    		                                    	/>
    		                                    	<img hidden id="building_iamSmartFilled" className="iamSmartFilled" src={iamSmartFilled} alt="" />
    		                                    	{!!errors.building ? <img id="building_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
    	                                        </div>
                                            </FormControl>
                                            <FormControl
                                                error={!!errors.street}
                                            >
    		                                    <div className="row">
    	                                            <BootstrapInput
    	                                                name="street"
                                                        id="street"
    	                                                //defaultValue={data.street}
    	                                                inputRef={register}
    	                                                placeholder={t('step2.contactInfo.street') + " (" + t('step2.contactInfo.eg') + t('step2.contactInfo.egStreet') + ")"}
    		                                    		onChange={modified.bind(this)}
                                                        inputProps={{ 
                                                            "aria-labelledby": "street",
                                                            "maxlength": "60"
                                                        }}
    		                                    	/>
    		                                    	<img hidden id="street_iamSmartFilled" className="iamSmartFilled" src={iamSmartFilled} alt="" />
    		                                    	{!!errors.street ? <img id="street_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
    	                                        </div>
                                            </FormControl>

                                            <FormControl
                                                className="district"
                                                error={!!errors.district}
                                            >
    		                                    <div className="row">
    	                                            <InputLabel shrink htmlFor="district" className="hiddenLabel">{t('step2.contactInfo.district')}</InputLabel>
    	                                            <Controller
    	                                                control={control}
    	                                                name='district'
    	                                                id="districtInput"
    	                                                //defaultValue={data.district}
    	                                                render={(selectProps) => (
    	                                                    <Select
	                                                        	{...selectProps}
    	                                                        displayEmpty
    	                                                        id="district"
                                                                onChange={(event)=>{
                                                                	modified(selectProps.name)
                                                                	selectProps.onChange(event.target.value);
                                                                }}
                                                                inputProps={{ 
                                                                    "aria-labelledby": "district"
                                                                }}
    	                                                    >
    	                                                        <MenuItem value="" disabled>{t('step2.contactInfo.district')}</MenuItem>
    	                                                        {districtList.map((district, districtIdx) => {
    	                                                            return (
    	                                                                <MenuItem
    	                                                                    key={districtIdx}
    	                                                                    value={t(district, {lng: "en"})}
    	                                                                >
    	                                                                    {t(district)}
    	                                                                </MenuItem>
    	                                                            )
    	                                                        })}
    	                                                    </Select>
    	                                                )}
    		                                    	/>    	                                            
    		                                    	<img hidden id="district_iamSmartFilled" className="iamSmartFilled" src={iamSmartFilled} alt="" />
    		                                    	{!!errors.district ? <img id="district_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
    	                                        </div>
                                            </FormControl>
                                        </Box>
}
                                            <div hidden id="filled_iamSmartFilled">
                                        		<img className="iamSmartFilled" src={iamSmartFilled} alt="" />
                                        		{t('step2.iamSmart.filled')}
                                        	</div>
                                    </Box>
                                </FormBox>
                                <FormBox>
                                    <Box
                                        display="flex"
                                        justifyContent="flex-end"
                                    >
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            className="secBtn"
                                            onClick={handleBack}
                                        >
                                            {t('common.button.back')}
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            className="secBtn"
                                            onClick={handleReset}
                                        >
                                            {t('common.button.clear')}
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                        >
                                            {t('common.button.next')}
                                        </Button>
                                    </Box>
                                </FormBox>
                            </form>
                        </Box>
                    </Box>
                </Box>
                <Footer />
            </div>
        </main>
    )
})
